import { ControlType, FormFieldBase } from './form-field-base.model';

export class SwitchFormField extends FormFieldBase<boolean> {
  controlType: ControlType = 'switch';
}
